import React from 'react';
import { Form, Input, DatePicker, Radio } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { Store } from 'antd/lib/form/interface';
import {
  WorksProfileType,
  SubmittalPacketType,
} from '@clinician-profile/graphql';
import { SubmittalPacketsMainInput } from 'works/legacy/components/submittal-packets-main-input';
import { SubmittalPacketsPreviewModalLink } from 'works/legacy/components/submittal-packets-preview-modal-link';
import { Moment } from 'moment';
import { EmploymentTypes } from '@common/graphql';
import { StaffingRequestTypeType } from '@applicant-flow/types/staffing-request';

type InitialValues = {
  availableToStartAt?: string | Date | Moment;
  timeoffDescription?: string;
  interviewAvailability?: string;
  employmentType?: EmploymentTypes;
  submittalPacket?: SubmittalPacketType;
  reasonForSubmission?: string;
};

type StaffingRequestSubmissionFormProps = {
  onFormFinish?: (values: Store) => void;
  formSubmitting?: boolean;
  initialValues?: InitialValues;
  form?: FormInstance;
  worksProfile: WorksProfileType;
  doNotRehire?: boolean;
  staffingRequestType?: StaffingRequestTypeType;
};

export function StaffingRequestSubmissionForm({
  onFormFinish,
  formSubmitting = false,
  initialValues = {},
  form,
  worksProfile,
  doNotRehire = false,
  staffingRequestType,
}: StaffingRequestSubmissionFormProps) {
  return (
    <Form
      layout="vertical"
      onFinish={onFormFinish}
      form={form}
      initialValues={initialValues}
    >
      <Form.Item
        label="Available to start"
        name="availableToStartAt"
        rules={[
          {
            required: true,
            message: 'Select a start date',
          },
        ]}
      >
        <DatePicker
          placeholder="Select a start date"
          format="MM/DD/YYYY"
          size="large"
          style={{ width: '100%' }}
          disabled={formSubmitting}
        />
      </Form.Item>
      <Form.Item
        label="Requested time off"
        name="timeoffDescription"
        initialValue="N/A"
        rules={[
          {
            required: true,
            message: 'Please enter details about upcoming time off',
          },
        ]}
      >
        <Input
          size="large"
          disabled={formSubmitting}
          placeholder="Provide the candidate's requested time off"
        />
      </Form.Item>
      <Form.Item
        label="Interview availability"
        name="interviewAvailability"
        initialValue="N/A"
        rules={[
          {
            required: true,
            message: 'Please enter interview availability details',
          },
        ]}
      >
        <Input
          size="large"
          disabled={formSubmitting}
          placeholder="Provide the candidate's availability for interviews"
        />
      </Form.Item>

      {staffingRequestType === 'long_term' && (
        <Form.Item
          label="Employment Type"
          name="employmentType"
          initialValue="traveler"
          rules={[
            { required: true, message: 'Please select an employment type' },
          ]}
        >
          <Radio.Group
            buttonStyle="solid"
            size="large"
            disabled={formSubmitting}
          >
            <Radio.Button key="traveler" value="traveler">
              Traveler
            </Radio.Button>
            <Radio.Button key="local" value="local">
              Local
            </Radio.Button>
            <Radio.Button key="direct_sourcing" value="direct_sourcing">
              Direct Sourcing
            </Radio.Button>
          </Radio.Group>
        </Form.Item>
      )}

      <Form.Item label="Submittal Packet">
        {formSubmitting ? (
          <SubmittalPacketsPreviewModalLink
            submittalPacket={initialValues.submittalPacket}
          />
        ) : (
          <SubmittalPacketsMainInput
            submittalPackets={worksProfile.worksSubmittalPackets}
          />
        )}
      </Form.Item>

      {formSubmitting && doNotRehire && (
        <Form.Item label="Reason for Submission" name="reasonForSubmission">
          <Input.TextArea disabled rows={3} />
        </Form.Item>
      )}
    </Form>
  );
}
